module.exports = __webpack_public_path__ + "media/images/common/my_nav_1-da87301d3cc2a8b36897c41f6c8b2476.png";